import React, { useState, useEffect } from "react";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle
} from "@mui/material";
import { Card, Alert } from "reactstrap";
import Layout from "../../components/Wrappers/Layout";
import BackButton from "../../components/BackButton/BackButton";
import { useSelector, useDispatch } from "react-redux";
import SearchIcon from "@mui/icons-material/Search";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
// import Tooltip from "@mui/material/Tooltip";
import { Tooltip } from "antd";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { makeStyles } from "@mui/styles";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import { NavLink, Link, useHistory, useNavigate } from "react-router-dom";
import { AiOutlineSearch } from "react-icons/ai";
import { getKycConfigurationList } from "../../redux/actions/getKycConfigurationListAction";
import { deleteKycConfigurationRecord } from "../../redux/actions/deleteKycConfigurationRecordAction";
import {
	resetGetKycConfigurationDetails,
	getKycConfigurationDetails
} from "../../redux/actions/getKycConfigurationDetailsAction";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";

const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});

const KycConfigration = () => {
	const [isLoading, setIsLoading] = useState(false);
	const classes = useStyles();
	const navigate = useHistory();
	const [rowsPerPage, setRowsPerPage] = useState(5);
	const [page, setPage] = useState(0);
	const [role, setRole] = useState("");
	const [entity, setEntity] = useState("");
	const [notificationOpen, setNotificationOpen] = useState(false);
	const dispatch = useDispatch();

	const [getKycConfigurationStatus, setGetKycConfigurationStatus] =
		useState(false);
	const [getKycConfigurationResArray, setGetKycConfigurationStatusResArray] =
		useState("");
	const [roleDelete, setRoleDelete] = useState("");
	const [entityDelete, setEntityDelete] = useState("");
	const [kycLevelDelete, setKycLevelDelete] = useState("");
	const [open, setOpen] = useState(false);
	const [deleteStatus, setDeleteStatus] = useState(false);
	const [deleteKYCArray, setDeleteKYCArray] = useState([]);

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const getWalletRolesRes = useSelector(
		({ walletAcRequired }) => walletAcRequired
	);

	const getKycConfigurationListRes = useSelector(
		({ getKycConfigurationList }) => getKycConfigurationList
	);

	const deleteKycConfigurationRecordRes = useSelector(
		({ deleteKycConfigurationRecord }) => deleteKycConfigurationRecord
	);

	const handleNoticationClose = () => {
		setNotificationOpen(false);
	};

    const login = useSelector(({login}) => login);

	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	var authToken = regenerateTokenRes.data.AuthToken;

	useEffect(() => {
		dispatch(resetGetKycConfigurationDetails());
	}, []);

	const handleChange = ({ target: { name, value } }) => {
		if (name === "role") {
			setRole(value == "Select Role" ? "" : value);
		}

		if (name === "entity") {
			setEntity(value == "Select Entity Type" ? "" : value);
		}
	};

	const getKycConfigurationReq = () => {
		setIsLoading(true);
		setGetKycConfigurationStatus(true);
		const req = {
			actionCustomerMasterRequestVO: {
				walletOwnerId: regenerateTokenRes.data.partnerId || "",
				// subRole: login.data.subRole,
				role: role == "Select Role" ? "" : role,

				entityType: entity
			}
		};

		return dispatch(
			getKycConfigurationList(req, regenerateTokenRes.data.AuthToken)
		);
	};

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			getKycConfigurationReq();
		}
	}, [regenerateTokenRes.data.status]);

	const getKycConfigurationReqFunc = () => {
		if (getKycConfigurationStatus) {
			if (getKycConfigurationListRes.data.status == "success") {
				setIsLoading(false);
				setGetKycConfigurationStatusResArray(
					[].concat(getKycConfigurationListRes.data.kycMappingList)
				);
			}
			if (getKycConfigurationListRes.data.status == "failed") {
				setIsLoading(false);
				setGetKycConfigurationStatusResArray(
					[].concat(getKycConfigurationListRes.data.kycMappingList)
				);
				if (
					getKycConfigurationListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getKycConfigurationListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (getKycConfigurationListRes.data.status == "Failed") {
				setIsLoading(false);
				setGetKycConfigurationStatusResArray(getKycConfigurationListRes.data);
				if (
					getKycConfigurationListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getKycConfigurationListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		getKycConfigurationReqFunc();
	}, [getKycConfigurationListRes.data.status]);

	useEffect(() => {
		if (getKycConfigurationListRes.data.status == "success") {
			setPage(0);
		}
	}, [getKycConfigurationListRes.data.status]);

	const deleteIntegrationFunc = (kycLevel, role, entity) => {
		setKycLevelDelete(kycLevel);
		setRoleDelete(role);
		setEntityDelete(entity);
		setOpen(true);
	};

	const deleteKycConfigurationRecords = () => {
		setDeleteStatus(true);
		setOpen(false);
		let req = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			},
			actionCustomerMasterRequestVO: {
				role: roleDelete,
				entityType: entityDelete,
				kycLevel: kycLevelDelete
			}
		};
		dispatch(
			deleteKycConfigurationRecord(req, regenerateTokenRes.data.AuthToken)
		);
	};

	const deleteKYCResFunc = () => {
		if (deleteStatus) {
			if (deleteKycConfigurationRecordRes.data.status == "success") {
				setDeleteKYCArray(deleteKycConfigurationRecordRes.data);
				setNotificationOpen(true);
				getKycConfigurationReq();
			}
			if (deleteKycConfigurationRecordRes.data.status == "Failed") {
				setDeleteKYCArray(deleteKycConfigurationRecordRes.data);
				setNotificationOpen(true);
				if (
					deleteKycConfigurationRecordRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					deleteKycConfigurationRecordRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (deleteKycConfigurationRecordRes.data.status == "failed") {
				setDeleteKYCArray(deleteKycConfigurationRecordRes.data);
				setNotificationOpen(true);
				if (
					deleteKycConfigurationRecordRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					deleteKycConfigurationRecordRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		if (deleteKycConfigurationRecordRes.data.status == "Failed") {
			setPage(0);
			if (
				deleteKycConfigurationRecordRes.data.description == "session out"
			) {
				SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
			}
			if (
				deleteKycConfigurationRecordRes.data.description == "Authorization failed"
			) {
				regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
			}
		}
	}, [deleteKycConfigurationRecordRes.data.status]);

	useEffect(() => {
		deleteKYCResFunc();
	}, [deleteKycConfigurationRecordRes.data.status]);

	const handleClose = () => {
		setOpen(false);
		setRole("");
		setEntity("");
	};

	const editKycConf = (id, role, entity, kycLevel) => {
		navigate.push({
			pathname: `/index/edit-kyc-configuration`,
			state: {
				param1: `${id}`,
				param2: `${role}`,
				param3: `${entity}`,
				param4: `${kycLevel}`
			}
		});
	};

	return (
		<>
			<Layout>
				<Card>
					<Grid
						container
						style={{ padding: "25px", gap: "20px", justifyContent: "right" }}
					>
						<Grid item md={3} sm={12} xs={12} lg={3}>
							<NavLink to="/index/add-new-kyc-configuration">
								<CustomButton
									style={{
										padding: "8px"
									}}
								>
									Add New KYC Configuration
								</CustomButton>
							</NavLink>
						</Grid>
						<Grid item md={3} sm={12} xs={12} lg={3}>
							<NavLink to="/index/KycLevel">
								<CustomButton
									style={{
										padding: "8px"
									}}
								>
									KYC Display Label
								</CustomButton>
							</NavLink>
						</Grid>

					</Grid>

					<Grid
						container
						spacing={2}
						style={{ padding: "25px", marginTop: "2rem" }}
					>
						<Grid item xs={12} sm={12} md={4} lg={4}>
							<TextField
								select
								// required
								autoFocus
								margin="dense"
								id="name"
								label="Role"
								fullWidth
								variant="standard"
								type="text"
								name="role"
								defaultValue={"Select Role" || role}
								onChange={handleChange}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							>
								<MenuItem value="Select Role" selected="Select Role">
									Select Role
								</MenuItem>
								{getWalletRolesRes.success &&
									getWalletRolesRes.data.rolesList.map((x) => (
										<MenuItem value={x}>{x}</MenuItem>
									))}
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={4} lg={4}>
							<TextField
								select
								// required
								autoFocus
								margin="dense"
								id="name"
								label="Entity Type"
								fullWidth
								variant="standard"
								type="text"
								name="entity"
								defaultValue={"Select Entity Type" || entity}
								onChange={handleChange}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							>
								<MenuItem
									value="Select Entity Type"
									selected="Select Entity Type"
								>
									Select Entity Type
								</MenuItem>
								<MenuItem value="Individual">Individual</MenuItem>
								<MenuItem value="Legal">Legal</MenuItem>
							</TextField>
						</Grid>
						<Grid
							item
							xs={12}
							sm={12}
							md={4}
							lg={4}
							style={{
								padding: "10px",
								marginTop: "0.5rem",
								marginBottom: "15px"
							}}
						>
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={getKycConfigurationReq}
							>
								Search <SearchIcon />
							</CustomButton>
						</Grid>
					</Grid>
				</Card>

				{isLoading ? (
					<LoadingSpinner />
				) : getKycConfigurationResArray.length == undefined ||
					!getKycConfigurationStatus ? (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography
									variant="body1"
									style={{ fontWeight: "700" }}
									className="themeText"
								>
									KYC Configuration List
								</Typography>
							</Grid>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Alert
									className="my-3 tableHeaderColor"
									variant="secondary"
									style={{ color: "white" }}
								>
									No Records Found!
								</Alert>
							</Grid>
						</Grid>
					</Card>
				) : (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography
									variant="body1"
									style={{ fontWeight: "700" }}
									className="themeText"
								>
									KYC Configuration List
								</Typography>
							</Grid>
							<TableContainer component={Paper} className="my-3">
								<Table className={classes.table}>
									<TableHead>
										<TableRow className="tableHeaderColor">
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												KYC Level
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Role
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Entity Type
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Action
											</TableCell>
										</TableRow>
									</TableHead>

									<TableBody>
										{getKycConfigurationResArray &&
											[]
												.concat(getKycConfigurationResArray)
												.slice(
													page * rowsPerPage,
													page * rowsPerPage + rowsPerPage
												)
												.map((row, index) => (
													<TableRow key={index}>
														<TableCell align="center">{row.kycLevel}</TableCell>
														<TableCell align="center">{row.role}</TableCell>
														<TableCell align="center">
															{row.entityType}
														</TableCell>
														<TableCell align="center">
															<Tooltip title="Edit">
																<CustomButton
																	style={{
																		padding: "8px",
																		marginRight: "10px"
																	}}
																	onClick={() =>
																		editKycConf(
																			row.partnerId,
																			row.role,
																			row.entityType,
																			row.kycLevel
																		)
																	}
																>
																	{
																		<EditIcon
																			style={{
																				color: "#fff",
																				fontSize: "20px"
																			}}
																		/>
																	}
																</CustomButton>
															</Tooltip>

															<Tooltip title="Delete">
																<CustomButton
																	style={{
																		padding: "8px"
																	}}
																	onClick={() =>
																		deleteIntegrationFunc(
																			row.kycLevel,
																			row.role,
																			row.entityType
																		)
																	}
																>
																	{
																		<DeleteIcon
																			style={{
																				color: "#fff",
																				fontSize: "20px"
																			}}
																		/>
																	}
																</CustomButton>
															</Tooltip>
														</TableCell>
													</TableRow>
												))}
									</TableBody>
								</Table>
								<TablePagination
									rowsPerPageOptions={[5, 10, 25]}
									component="div"
									count={getKycConfigurationResArray.length}
									rowsPerPage={rowsPerPage}
									page={page}
									onPageChange={handleChangePage}
									onRowsPerPageChange={handleChangeRowsPerPage}
								/>
							</TableContainer>
						</Grid>
					</Card>
				)}
				<div>
					<Dialog open={open} onClose={handleClose}>
						<DialogTitle style={{ width: "400px" }}>Are you sure you want to delete?</DialogTitle>
						<DialogActions className="p-3">
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handleClose}
							>
								Cancel
							</CustomButton>
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={deleteKycConfigurationRecords}
							>
								Yes
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			</Layout>

			{/* <div>
        <Dialog open={open} onClose={handleClose}>
          <DialogTitle>Edit Customer/Merchant Wallet</DialogTitle>
          <DialogContent>
            <TextField
              // defaultValue={"Select Currency"}
              size="small"
              color="primary"
              autoFocus={true}
              type="text"
              label="Customer/Merchant ID*"
              value={editCustomerMerchantID}
              name="editCustomerMerchantID"
              fullWidth={true}
              select
              onChange={handleChange}
            >
              {(() => {
                if (getCustomerIdAndNameListRes) {
                  if (!getCustomerIdAndNameListRes.data.currencyList) {
                    return <MenuItem>No Customer/Merchant ID</MenuItem>;
                  }
                  return []
                    .concat(getCustomerIdAndNameListRes.data.currencyList)
                    .map((c) => (
                      <MenuItem value={c} key={c}>
                        {c}
                      </MenuItem>
                    ));
                }
              })()}
            </TextField>

            <TextField
              select
              required
              size="small"
              color="primary"
              autoFocus={true}
              type="text"
              label="Currency"
              fullWidth={true}
              name="editCurrency"
              value={editCurrency || ""}
              onChange={handleChange}
            >
              {adminCurrencyList.success &&
                adminCurrencyList.data.currencyList.map((x) => (
                  <MenuItem value={x}>{x}</MenuItem>
                ))}
            </TextField>

            <TextField
              margin="dense"
              id="name"
              label="Wallet Name"
              type="name"
              fullWidth
              variant="standard"
              value={walletName || ""}
              name="walletName"
              onChange={handleChange}
            />
          </DialogContent>
          <DialogActions>
            <Button
              style={{
                backgroundColor: "#fff",
                color: "#000",
              }}
              variant="contained"
              onClick={handleClose}
            >
              Cancel
            </Button>
            <Button
              style={{
                backgroundColor: "#00b9f5",
                color: "white",
              }}
              variant="contained"
              onClick={updateCustomerWallet}
            >
              Save
            </Button>
          </DialogActions>
        </Dialog>
      </div> */}

			{deleteKYCArray.status == "success" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent className="text-center"
						style={{ backgroundColor: "#00b9f51c" }}
						
						>
							<img src={success} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{deleteKycConfigurationRecordRes.data.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{deleteKYCArray.status == "Failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent className="text-center"
						style={{ backgroundColor: "#00b9f51c" }}
						
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{deleteKycConfigurationRecordRes.data.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{deleteKYCArray.status == "failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent className="text-center"
						style={{ backgroundColor: "#00b9f51c" }}
						
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{deleteKycConfigurationRecordRes.data.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}
		</>
	);
};

export default KycConfigration;
